
<component
  :is="as"
  :class="['btn', kind, { block, large, floating, loading }]"
  :type="type"
  v-bind="$attrs"
  v-on="$listeners"
>
  <span v-if="loading">
    <spinner
      :class="['loading-spinner', { 'has-text': loadingText }]"
      size="16"
      inline
      :light="kind !== 'secondary'"
    />

    <span v-if="loadingText" class="text">{{ loadingText }}</span>
  </span>

  <span v-else>
    <span><slot /></span>
    <icon v-if="icon" :name="icon" class="icon" />
  </span>
</component>
